import AttachFileRounded from "@mui/icons-material/AttachFileRounded";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { useEffect, useState } from "react";
import FilePreview from "../common/FilePreview";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import RffForm from "./RffForm";

const RffFormWithFilePreview = ({
  children,
  initialValues,
  formSpy,
  onSubmit,
  loading,
  suppressFooter,
  submitText,
  files,
  sx,
}) => {
  return (
    <Flx g={4} sx={sx}>
      <RffForm
        loading={loading}
        initialValues={initialValues}
        formSpy={formSpy}
        submitText={submitText}
        suppressFooter={suppressFooter}
        onSubmit={onSubmit}
        sx={{ minWidth: "600px" }}
      >
        {children}
      </RffForm>
      <Divider flexItem orientation="vertical" />
      <FilePreviewRenderer files={files} />
    </Flx>
  );
};

const FilePreviewRenderer = ({ files }) => {
  const [file, setFile] = useState(null);
  useEffect(() => {
    if (!isEmpty(files)) {
      setFile(files[0]);
    }
  }, [files]);

  if (isEmpty(files)) {
    return null;
  }

  return (
    <Flx column gap={1} sx={{ minWidth: "420px" }}>
      <Flx column gap={1}>
        <Txt bold>Uploaded Files</Txt>
        <Flx gap={1} wrap>
          {files?.map((f) => (
            <Button
              key={f._id}
              startIcon={
                <AttachFileRounded
                  className="thin"
                  sx={{ mr: -1, fontSize: "14px !important" }}
                />
              }
              variant={"text"}
              onClick={() => setFile(f)}
              sx={{
                minWidth: "50px",
                fontWeight: file?._id === f._id ? "bold" : 400,
                p: 0,
                mr: 1,
                textTransform: "none",
              }}
            >
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  width: "100%",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {f.file_display_name || f.name}
              </Box>
            </Button>
          ))}
        </Flx>
      </Flx>
      {isNil(file) ? null : (
        <FilePreview
          fileDisplayName={file?.file_display_name}
          loanId={file?.containerName}
          fileObject={file}
          sx={{
            width: "100%",
          }}
        />
      )}
    </Flx>
  );
};
export default RffFormWithFilePreview;
